import { trustBadges } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20composition%20of%20curated%20fashion%20essentials%20including%20sneakers%20hoodie%20cap%20and%20accessories%20on%20smooth%20cream%20marble%20surface%20with%20dramatic%20soft%20natural%20window%20light%20casting%20elegant%20shadows%20from%20upper%20left%20sophisticated%20warm%20neutral%20tones%20minimalist%20luxury%20product%20photography%20with%20generous%20breathing%20space%20and%20refined%20aesthetic&width=1800&height=900&seq=hero-basetao-v2-01&orientation=landscape"
          alt="Basetao Spreadsheet fashion product showcase"
          title="Basetao Spreadsheet - Fashion Products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center py-16 md:py-24">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-white mb-4 tracking-tight">
          Basetao Spreadsheet
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-6 max-w-2xl mx-auto font-light leading-relaxed">
          The Complete Shopping Database, Review Hub &amp; Buying Guide
        </p>
        <p className="text-sm md:text-base text-white/75 mb-10 max-w-xl mx-auto leading-relaxed">
          Find, organize and manage your Basetao shopping experience with the most complete Basetao Spreadsheet resource. Explore verified guides, shipping cost comparisons, warehouse tips, coupon updates, discount strategies and expert reviews before placing your next order.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-900 font-semibold rounded-full text-sm hover:bg-white/90 transition-all duration-200"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {trustBadges.map((badge) => (
            <span
              key={badge}
              className="whitespace-nowrap inline-flex items-center gap-1.5 text-white/80 text-xs md:text-sm"
            >
              <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}